import {
  GET_LABREQUEST_FAIL,
  GET_LABREQUEST_SUCCESS,
  GET_LABREQUESTS_FAIL,
  GET_LABREQUESTS_SUCCESS,
  ADD_LABREQUEST_SUCCESS,
  ADD_LABREQUEST_FAIL,
  UPDATE_LABREQUEST_SUCCESS,
  UPDATE_LABREQUEST_FAIL,
  DELETE_LABREQUEST_SUCCESS,
  DELETE_LABREQUEST_FAIL,  
  SET_STATE_LABREQUEST,
  GET_LABREQUESTSREPORTDETAIL_SUCCESS,
  GET_LABREQUESTSREPORTDETAIL_FAIL,
} from "./actionTypes";

const INIT_STATE = {
  labRequests: [],
  labRequest: {},
  labRequestsReportDetail: {},
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const labRequests = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LABREQUESTS_SUCCESS:
      return {
        ...state,
        labRequests: action.payload.labRequests,
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case SET_STATE_LABREQUEST:
      return { ...state, loading: action.payload }

    case GET_LABREQUESTS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_LABREQUESTSREPORTDETAIL_SUCCESS:
      return {
        ...state,
        labRequestsReportDetail: action.payload.labRequestsReportDetail,
      };

    case SET_STATE_LABREQUEST:
      return { ...state, loading: action.payload }

    case GET_LABREQUESTSREPORTDETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_LABREQUEST_SUCCESS:
      return {
        ...state,
        labRequests: [...state.labRequests, action.payload],
      };

    case ADD_LABREQUEST_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_LABREQUEST_SUCCESS:
      return {
        ...state,
        labRequests: state.labRequests.map(labRequest =>
          labRequest.id.toString() === action.payload.id.toString()
            ? action.payload
            : labRequest
        ),
      };

    case UPDATE_LABREQUEST_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_LABREQUEST_SUCCESS:
      return {
        ...state,
        labRequests: state.labRequests.filter(
          labRequest => labRequest.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_LABREQUEST_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_LABREQUEST_SUCCESS:
      return {
        ...state,
        labRequest: action.payload,
      };

    case GET_LABREQUEST_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default labRequests;
